import { useSyncExternalStore } from 'react';

/** Hash routes so the SPA works from any sub-path on shared hosting without server rewrites. */
export type Route =
  | { name: 'dashboard' }
  | { name: 'board'; id: string; view: string | null; split: string | null }
  | { name: 'local'; id: string; view: string | null }
  | { name: 'share'; token: string; view: string | null }
  | { name: 'login' }
  | { name: 'register'; invite: string | null };

export const paths = {
  dashboard: '#/',
  board: (id: string, split?: string | null) => (split ? `#/b/${id}?split=${split}` : `#/b/${id}`),
  local: (id = 'local') => `#/local/${id}`,
  share: (token: string) => `#/s/${token}`,
  login: '#/login',
  register: (invite?: string) => (invite ? `#/register?invite=${encodeURIComponent(invite)}` : '#/register'),
};

export function parseRoute(hash: string): Route {
  const h = hash.replace(/^#/, '');
  const [path = '', query = ''] = h.split('?');
  const parts = path.split('/').filter(Boolean);
  const params = new URLSearchParams(query);
  switch (parts[0]) {
    case 'b':
      if (parts[1]) return { name: 'board', id: parts[1], view: params.get('view'), split: params.get('split') };
      break;
    case 'local':
      return { name: 'local', id: parts[1] ?? 'local', view: params.get('view') };
    case 's':
      if (parts[1]) return { name: 'share', token: parts[1], view: params.get('view') };
      break;
    case 'login':
      return { name: 'login' };
    case 'register':
      return { name: 'register', invite: params.get('invite') };
  }
  return { name: 'dashboard' };
}

export function navigate(to: string): void {
  if (window.location.hash === to) return;
  window.location.hash = to;
}

const subscribe = (cb: () => void) => {
  window.addEventListener('hashchange', cb);
  return () => window.removeEventListener('hashchange', cb);
};

export function useRoute(): Route {
  const hash = useSyncExternalStore(subscribe, () => window.location.hash);
  return parseRoute(hash);
}
